import { schema } from 'normalizr';

export const name = 'stripeSubscriptions';

export const subscriptionSchema = new schema.Entity(name);

export const subscriptionCollectionSchema = new schema.Array(
  subscriptionSchema,
);
